import React, { useEffect, ReactNode } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import styled from "styled-components";

import { Col, Container, Row } from "../../util/styledBootstrapGridWrapper";
import Footer from "../Footer";
import LoginMenuContainer from "../LoginMenuContainer";
import Navigation from "../Navigation";
import Title from "../Title";
import { UnstyledLink } from "../Typography";

const PageTitleRow = styled(Row)`
  padding-top: 2rem;
  padding-bottom: 2rem;
  @media screen and (max-width: 500px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
`;
PageTitleRow.displayName = "PageTitleRow";

const PageTitleCol = styled(Col)`
  /* Pushes next column to the rightworkaround until styled-bootstrap-grid
   * supports this */
  margin-right: auto;
`;
PageTitleCol.displayName = "PageTitleCol";

const HeaderContainer = styled.div`
  background-color: ${(props) => props.theme.headerBackgroundColor};
  color: ${(props) => props.theme.headerColor};
`;
HeaderContainer.displayName = "HeaderContainer";

const MainDiv = styled.div<{ $isFrontpage: boolean }>`
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto auto 1fr auto; // header navi content footer
  background: ${(props) =>
    props.$isFrontpage
      ? "linear-gradient(rgb(34, 72, 112) 0px, rgb(34, 72, 112) 300px, rgb(241, 243, 246) 1000px);"
      : "transparent"};
`;

interface DefaultLayoutProps {
  children: ReactNode;
  title: string;
}

const DefaultLayout = ({ children, title }: DefaultLayoutProps) => {
  useEffect(() => {
    document.title =
      title === ""
        ? "MusicDrill | Fun & Easy Music Learning"
        : `${title} | MusicDrill`;
  }, [title]);

  return (
    <MainDiv $isFrontpage={title === ""}>
      <HeaderContainer>
        <Container>
          <PageTitleRow>
            <PageTitleCol auto>
              <UnstyledLink tag={RRNavLink} to="/">
                <Title />
              </UnstyledLink>
            </PageTitleCol>
            <Col auto>
              {/* @ts-expect-error Props provided by Redux connect */}
              <LoginMenuContainer />
            </Col>
          </PageTitleRow>
        </Container>
      </HeaderContainer>

      <Navigation />

      <Container>{children}</Container>

      <Footer />
    </MainDiv>
  );
};

export default DefaultLayout;
